import {
  faSparkles,
  faGift,
  faLightbulb,
  faMedal,
  faTag,
  faArrowLeft,
} from '@fortawesome/pro-solid-svg-icons';
import { Box, Button, Heading, Text } from '@ui-lib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ConsentDialogContent.module.scss';
import { useSetUserPreferencesMutation } from './ConsentDialogContent.graphql';

type ConsentDialogContentProps = {
  onCloseDialog?: () => void;
  onBack?: () => void;
};

export const ConsentDialogContent: React.FC<React.PropsWithChildren<ConsentDialogContentProps>> = ({
  onCloseDialog,
  onBack,
}) => {
  const [setUserPreferencesMutation] = useSetUserPreferencesMutation();

  const setUserPreferences = async (marketingConsentValue: 'OPTED_OUT' | 'OPTED_IN') => {
    try {
      await setUserPreferencesMutation({
        variables: {
          input: {
            email_marketing: {
              value: marketingConsentValue,
            },
          },
        },
      });
    } catch (error) {
      const err = error instanceof Error ? error : new Error('Error updating marketing consent');
    }
    onCloseDialog && onCloseDialog();
  };

  return (
    <div className={styles['consent-dialog-content']}>
      <div className={styles['consent-dialog-content__left']}>
        {onBack ? (
          <div className={styles['back-btn-container']}>
            <Button onClick={onBack} variant="text" iconLeading={<FontAwesomeIcon icon={faArrowLeft} />} />
          </div>
        ) : null}

        <div className={styles['consent-dialog-content__left--inner']}>
          <Box gap="medium" marginBottom={'large'} display={'flex'} flexDirection={'column'}>
            <Heading level={'4'}>Can we send you amazing things?</Heading>
            <Text>Control what we send in Email Preferences</Text>
          </Box>
          <div className={styles['list']}>
            <ul>
              <li>
                <div className={styles['list__icon']}>
                  <FontAwesomeIcon icon={faSparkles} />
                </div>
                <div className={styles['list__content']}>
                  <div className={styles['list__title']}>What’s new </div>
                  <div>Updates on new Blinq releases</div>
                </div>
              </li>
              <li>
                <div className={styles['list__icon']}>
                  <FontAwesomeIcon icon={faGift} />
                </div>
                <div className={styles['list__content']}>
                  <div className={styles['list__title']}>What you&apos;ve missed</div>
                  <div>Blinq products tailored just for you</div>
                </div>
              </li>
              <li>
                <div className={styles['list__icon']}>
                  <FontAwesomeIcon icon={faLightbulb} />
                </div>
                <div className={styles['list__content']}>
                  <div className={styles['list__title']}>Recommendations</div>
                  <div>Professional networking tips and more</div>
                </div>
              </li>
              <li>
                <div className={styles['list__icon']}>
                  <FontAwesomeIcon icon={faMedal} />
                </div>
                <div className={styles['list__content']}>
                  <div className={styles['list__title']}>Achievements and milestones</div>
                  <div>Recognizing your accomplishments</div>
                </div>
              </li>
              <li>
                <div className={styles['list__icon']}>
                  <FontAwesomeIcon icon={faTag} />
                </div>
                <div className={styles['list__content']}>
                  <div className={styles['list__title']}>Exclusive deals</div>
                  <div>Promotions only made available to our email list</div>
                </div>
              </li>
            </ul>
          </div>
          <div className={styles['buttons']}>
            <Button
              width="full"
              onClick={async () => {
                await setUserPreferences('OPTED_IN');
              }}
            >
              Yes, subscribe
            </Button>
            <Button
              width="full"
              variant="text"
              onClick={async () => {
                await setUserPreferences('OPTED_OUT');
              }}
            >
              Not now
            </Button>
          </div>
        </div>
      </div>
      <div className={styles['consent-dialog-content__right']}>
        <img src="/img/marketing-consent-iphone.png" alt="Marketing consent illustration" />
      </div>
    </div>
  );
};
